export default __webpack_public_path__ + "static/media/M.1.1 .8c429cf7.svg";